"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var api_internal_contract_js_1 = require("@tableau/api-internal-contract-js");
var api_external_contract_js_1 = require("@tableau/api-external-contract-js");
var ExternalToInternalEnumMappings_1 = require("../../EnumMappings/ExternalToInternalEnumMappings");
var ExportHelpers_1 = require("../../Utils/ExportHelpers");
var ErrorHelpers_1 = require("../../Utils/ErrorHelpers");
var TableauError_1 = require("../../TableauError");
var ServiceImplBase_1 = require("./ServiceImplBase");
var ExportServiceImpl = /** @class */ (function (_super) {
    __extends(ExportServiceImpl, _super);
    function ExportServiceImpl() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(ExportServiceImpl.prototype, "serviceName", {
        get: function () {
            return "export-service" /* Export */;
        },
        enumerable: true,
        configurable: true
    });
    ExportServiceImpl.prototype.getExportCrosstabSheetMapAsync = function (currentSheetType) {
        var _a;
        var verb = api_internal_contract_js_1.VerbId.GetExportCrosstabSheetMap;
        var parameters = (_a = {},
            _a[api_internal_contract_js_1.ParameterId.FunctionName] = 'getExportCrosstabSheetMapAsync',
            _a[api_internal_contract_js_1.ParameterId.CurrentSheetType] = ExternalToInternalEnumMappings_1.ExternalToInternalEnumMappings.sheetType.convert(currentSheetType),
            _a);
        return this.execute(verb, parameters).then(function (response) {
            var result = response.result;
            return result;
        });
    };
    ExportServiceImpl.prototype.exportCrosstabAsync = function (sheetName, format, exportableWorksheetNames, currentSheetType) {
        return __awaiter(this, void 0, void 0, function () {
            var sheetNameToIdMap, parameters, verb;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        ErrorHelpers_1.ErrorHelpers.verifySheetName(exportableWorksheetNames, sheetName);
                        ErrorHelpers_1.ErrorHelpers.verifyEnumValue(format, api_external_contract_js_1.CrosstabFileFormat, 'CrosstabFileFormat');
                        return [4 /*yield*/, this.getExportCrosstabSheetMapAsync(currentSheetType)];
                    case 1:
                        sheetNameToIdMap = _b.sent();
                        if (!sheetNameToIdMap[sheetName]) {
                            throw new TableauError_1.TableauError(api_external_contract_js_1.SharedErrorCodes.InternalError, 'missing sheet doc id from sheetMap');
                        }
                        parameters = (_a = {},
                            _a[api_internal_contract_js_1.ParameterId.FunctionName] = 'exportCrosstabAsync',
                            _a[api_internal_contract_js_1.ParameterId.SheetIdentifier] = sheetNameToIdMap[sheetName],
                            _a[api_internal_contract_js_1.ParameterId.SendNotifications] = true,
                            _a);
                        switch (format) {
                            case api_external_contract_js_1.CrosstabFileFormat.CSV:
                                verb = api_internal_contract_js_1.VerbId.ExportCrosstabCsvDownload;
                                // CSV only parameter: see browser-clients/export-crosstab-options-dialog repo
                                parameters[api_internal_contract_js_1.ParameterId.UseTabDelimiters] = true;
                                break;
                            case api_external_contract_js_1.CrosstabFileFormat.Excel:
                                verb = api_internal_contract_js_1.VerbId.ExportCrosstabExcelDownload;
                                break;
                            default:
                                throw new TableauError_1.TableauError(api_external_contract_js_1.SharedErrorCodes.InternalError, 'unsupported Crosstab file format.');
                        }
                        return [2 /*return*/, this.execute(verb, parameters)
                                .then(function (response) {
                                var result = response.result;
                                return result;
                            })
                                .catch(function () {
                                throw new TableauError_1.TableauError(api_external_contract_js_1.SharedErrorCodes.CrosstabCreationError, 'An unexpected error occurred while generating the document.');
                            })];
                }
            });
        });
    };
    ExportServiceImpl.prototype.exportDataAsync = function (visualId, options) {
        var _a;
        var _b;
        ErrorHelpers_1.ErrorHelpers.verifyExportDataOptions(options);
        // Remove any duplicates from the input array
        var columnsAsSet = new Set(options.columnsToIncludeById);
        var columnsToIncludeById = Array.from(columnsAsSet);
        var verb = api_internal_contract_js_1.VerbId.ExportDataDownload;
        var parameters = (_a = {},
            _a[api_internal_contract_js_1.ParameterId.FunctionName] = 'exportDataAsync',
            _a[api_internal_contract_js_1.ParameterId.VisualId] = visualId,
            _a[api_internal_contract_js_1.ParameterId.IgnoreAliases] = (_b = options.ignoreAliases, (_b !== null && _b !== void 0 ? _b : false)),
            _a[api_internal_contract_js_1.ParameterId.ColumnsToIncludeById] = columnsToIncludeById,
            _a);
        return this.execute(verb, parameters)
            .then(function () { })
            .catch(function () {
            throw new TableauError_1.TableauError(api_external_contract_js_1.SharedErrorCodes.DataCreationError, 'An unexpected error occurred while generating the document.');
        });
    };
    ExportServiceImpl.prototype.exportPowerPointAsync = function (sheetNames, exportScenarios) {
        var _a;
        ErrorHelpers_1.ErrorHelpers.verifySheetNamesForPDFAndPPT(sheetNames, exportScenarios);
        // Note: the ExportOriginUrl param is listed as optional for the pres layer command we are invoking; however,
        // recent changes were made that enforced the use of the empty string when invoking this command with no ExportOriginUrl.
        // see browser-clients/export-powerpoint-options-dialog repo.
        var verb = api_internal_contract_js_1.VerbId.ExportPowerpointDownload;
        var parameters = (_a = {},
            _a[api_internal_contract_js_1.ParameterId.FunctionName] = 'exportPowerPointAsync',
            _a[api_internal_contract_js_1.ParameterId.ExportOriginUrl] = '',
            _a[api_internal_contract_js_1.ParameterId.SelectedSheetNames] = sheetNames,
            _a);
        return this.execute(verb, parameters)
            .then(function (response) {
            var result = response.result;
            return result;
        })
            .catch(function () {
            throw new TableauError_1.TableauError(api_external_contract_js_1.SharedErrorCodes.PowerPointCreationError, 'An error occured while attempting to generate the PowerPoint file.');
        });
    };
    ExportServiceImpl.prototype.exportPDFAsync = function (sheetNames, externalExportPdfOptions, exportScenarios) {
        return __awaiter(this, void 0, void 0, function () {
            var internalExportPdfOptions, verb, parameters;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        ErrorHelpers_1.ErrorHelpers.verifyExportPDFOptions(externalExportPdfOptions);
                        ErrorHelpers_1.ErrorHelpers.verifySheetNamesForPDFAndPPT(sheetNames, exportScenarios);
                        return [4 /*yield*/, this.getExportPDFOptionsAsync()];
                    case 1:
                        internalExportPdfOptions = _b.sent();
                        ExportHelpers_1.ExportHelpers.updateInternalExportPDFOptions(internalExportPdfOptions, externalExportPdfOptions, sheetNames);
                        verb = api_internal_contract_js_1.VerbId.ExportPdfDownload;
                        parameters = (_a = {},
                            _a[api_internal_contract_js_1.ParameterId.FunctionName] = 'exportPDFAsync',
                            _a[api_internal_contract_js_1.ParameterId.ExportPdfOptions] = internalExportPdfOptions,
                            _a);
                        return [2 /*return*/, this.execute(verb, parameters)
                                .then(function (response) {
                                var result = response.result;
                                return result;
                            })
                                .catch(function () {
                                throw new TableauError_1.TableauError(api_external_contract_js_1.SharedErrorCodes.PDFCreationError, 'Unable to create PDF because something went wrong. Try again.');
                            })];
                }
            });
        });
    };
    ExportServiceImpl.prototype.getExportPDFOptionsAsync = function () {
        var _a;
        var verb = api_internal_contract_js_1.VerbId.GetExportPdfOptions;
        var parameters = (_a = {},
            _a[api_internal_contract_js_1.ParameterId.FunctionName] = 'getExportPdfOptionsAsync',
            _a);
        return this.execute(verb, parameters).then(function (response) {
            var result = response.result;
            return result;
        });
    };
    return ExportServiceImpl;
}(ServiceImplBase_1.ServiceImplBase));
exports.ExportServiceImpl = ExportServiceImpl;
//# sourceMappingURL=ExportServiceImpl.js.map